import * as departmentAction from './department-action'

export {
  departmentAction,
}



// WEBPACK FOOTER //
// ./src/actions/department/index.js